import qwest from 'qwest';

let forecastApi = {
  getForecast(zip) {
    if (zip.length === 10) {
      zip = zip.substring(0, 5);
    }
    return new Promise((resolve, reject) => {
      qwest.get(`/forecast/?zip=${zip}`)
        .then((xhr, response) => {
          if (response.success) {
            resolve(JSON.parse(response.data));
          } else {
            reject(response);
          }
        }).catch(()=> {
          reject();
        });
    });
  },
};

export default forecastApi;
